import script from "./SidebarSubtitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarSubtitle.vue?vue&type=script&setup=true&lang=ts"

import "./SidebarSubtitle.vue?vue&type=style&index=0&id=cb9bed58&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb9bed58"]])

export default __exports__